import { put, select, takeLatest, all } from 'redux-saga/effects';
import { privateCall } from './api.saga';
import { ppcActions } from '../reducers/ppc.reducer';
import { modalActions } from '../reducers/modal.reducer';
import { history } from '../store/store';

function* faq({ payload: { formData = {}, method = 'get', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.ppc.faq}${route ? `/${route}` : ''}`);
		const { faq } = yield privateCall({ endpoint, payload: formData, method });

		yield put(ppcActions.setFaq(faq));
	} catch (e) {}
}

function* forms({ payload: { formData = {}, method = 'get', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.ppc.forms}${route ? `/${route}` : ''}`);
		const { forms } = yield privateCall({ endpoint, payload: formData, method });

		yield put(ppcActions.setForms(forms));
	} catch (e) {}
}

function* contactPersons({ payload: { formData = {}, method = 'get', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.ppc.contactPersons}${route ? `/${route}` : ''}`);
		const { contacts } = yield privateCall({ endpoint, payload: formData, method });

		yield put(ppcActions.setContactPersons(contacts));
	} catch (e) {}
}

function* page({ payload: { formData = {}, method = 'get', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.ppc.page}${route ? `/${route}` : ''}`);

		const { index, details } = yield privateCall({ endpoint, payload: formData, method });

		if (method === 'post')
			yield put(modalActions.hide());
		// else if (method === 'delete' && !route) {
			// history.push(`/${pages[formData?.pageID]?.clientApp}/pages`);
		// }

		yield put(ppcActions.setPage({ details, index }));
	} catch (e) {}
}

function* pageComponent({ payload: { formData = {}, method = 'get', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.ppc.pageComponent}${route ? `/${route}` : ''}`);
		const { index, details } = yield privateCall({ endpoint, payload: formData, method });

		yield put(ppcActions.setPage({ details, index }));
	} catch (e) {}
}

function* construxHomeSlider({ payload: { formData = {}, method = 'get', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.ppc.construxHomeSlider}${route ? `/${route}` : ''}`);
		const { construxHomeSlider } = yield privateCall({ endpoint, payload: formData, method });

		yield put(ppcActions.setConstruxHomeSlider(construxHomeSlider));
	} catch (e) {}
}

function* productCategory({ payload: { formData = {}, method = 'get', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.ppc.productCategory}${route ? `/${route}` : ''}`);
		const { category } = yield privateCall({ endpoint, payload: formData, method });

		yield put(ppcActions.setProduct({ category }));
	} catch (e) {}
}

function* product({ payload: { formData = {}, method = 'get', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.ppc.product}${route ? `/${route}` : ''}`);
		const { details, index } = yield privateCall({ endpoint, payload: formData, method });

		yield put(ppcActions.setProduct({ details, index }));
	} catch (e) {}
}

function* serviceCategory({ payload: { formData = {}, method = 'get', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.ppc.serviceCategory}${route ? `/${route}` : ''}`);
		const { category } = yield privateCall({ endpoint, payload: formData, method });

		yield put(ppcActions.setService({ category }));
	} catch (e) {}
}

function* service({ payload: { formData = {}, method = 'get', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.ppc.service}${route ? `/${route}` : ''}`);
		const { details, index } = yield privateCall({ endpoint, payload: formData, method });

		yield put(ppcActions.setService({ details, index }));
	} catch (e) {}
}

function* altTag({ payload }) {
	try {
		const endpoint = yield select(s => s.config.endpoints.ppc.altTag);
		const { pages } = yield privateCall({ endpoint, payload, method: 'put' });

		if (pages)
			yield put(ppcActions.setPage(pages));

	} catch (e) {}
}

function* componentDetails({ payload }) {
	try {
		const endpoint = yield select(s => s.config.endpoints.ppc.componentDetails);
		const { pages } = yield privateCall({ endpoint, payload, method: 'put' });

		if (pages)
			yield put(ppcActions.setPage(pages));

	} catch (e) {}
}

function* sectionDetails({ payload }) {
	try {
		const endpoint = yield select(s => s.config.endpoints.ppc.sectionDetails);
		const { pages } = yield privateCall({ endpoint, payload, method: 'put' });

		if (pages)
			yield put(ppcActions.setPage(pages));

	} catch (e) {}
}

function* associations({ payload: { formData = {}, method = 'get', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.ppc.associations}${route ? `/${route}` : ''}`);
		const { associations } = yield privateCall({ endpoint, payload: formData, method });

		if (associations)
			yield put(ppcActions.setAssociations({ associations }));

	} catch (e) {}
}

function* clients({ payload: { formData = {}, method = 'get', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.ppc.clients}${route ? `/${route}` : ''}`);
		const { clients } = yield privateCall({ endpoint, payload: formData, method });

		if (clients)
			yield put(ppcActions.setClients({ clients }));

		if (method === 'delete')
			history.goBack();

	} catch (e) {}
}

function* location({ payload: { formData = {}, method = 'get', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.ppc.location}${route ? `/${route}` : ''}`);
		const { index, details } = yield privateCall({ endpoint, payload: formData, method });

		yield put(ppcActions.setLocation({ index, details }));
	} catch (e) {}
}

function* testimonials({ payload: { formData = {}, method = 'get', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.ppc.testimonials}${route ? `/${route}` : ''}`);
		const { testimonials } = yield privateCall({ endpoint, payload: formData, method });

		yield put(ppcActions.setTestimonials({ testimonials }));
	} catch (e) {}
}

// function* calendar({ payload: { formData = {}, method = 'get', route = null } }) {
// 	try {
// 		const endpoint = yield select(s => `${s.config.endpoints.ppc.calendar}${route ? `/${route}` : ''}`);
// 		const { calendarEvent, calendarEvents } = yield privateCall({ endpoint, payload: formData, method });

// 		if (calendarEvent)
// 			yield put(ppcActions.setCalendar({ [calendarEvent._id]: calendarEvent }));

// 		if (calendarEvents) {
// 			const normalized = {};

// 			calendarEvents.forEach(x => {
// 				normalized[x._id] = x;
// 			});

// 			yield put(ppcActions.setCalendar(normalized));
// 		}
// 	} catch (e) {}
// }

export default function* ppcSaga() {
	yield all([
		yield takeLatest(ppcActions.altTag, altTag),
		yield takeLatest(ppcActions.associations, associations),
		// yield takeLatest(ppcActions.calendar, calendar),
		yield takeLatest(ppcActions.clients, clients),
		yield takeLatest(ppcActions.componentDetails, componentDetails),
		yield takeLatest(ppcActions.construxHomeSlider, construxHomeSlider),
		yield takeLatest(ppcActions.contactPersons, contactPersons),
		yield takeLatest(ppcActions.faq, faq),
		yield takeLatest(ppcActions.forms, forms),
		yield takeLatest(ppcActions.location, location),
		yield takeLatest(ppcActions.page, page),
		yield takeLatest(ppcActions.pageComponent, pageComponent),
		yield takeLatest(ppcActions.product, product),
		yield takeLatest(ppcActions.productCategory, productCategory),
		yield takeLatest(ppcActions.sectionDetails, sectionDetails),
		yield takeLatest(ppcActions.service, service),
		yield takeLatest(ppcActions.serviceCategory, serviceCategory),
		yield takeLatest(ppcActions.testimonials, testimonials),
	]);
}
